import { render, staticRenderFns } from "./RoomPerformance.vue?vue&type=template&id=883336ba&scoped=true&"
import script from "./RoomPerformance.vue?vue&type=script&lang=ts&"
export * from "./RoomPerformance.vue?vue&type=script&lang=ts&"
import style0 from "./RoomPerformance.vue?vue&type=style&index=0&id=883336ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883336ba",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('883336ba')) {
      api.createRecord('883336ba', component.options)
    } else {
      api.reload('883336ba', component.options)
    }
    module.hot.accept("./RoomPerformance.vue?vue&type=template&id=883336ba&scoped=true&", function () {
      api.rerender('883336ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/rooms/room/RoomPerformance.vue"
export default component.exports